var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReportRankThird(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2146_3462)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2146_3462",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 56,
    height: 56
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H56V56H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2146_3462)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9375 27.0594H33.1331L47.1287 0H35.9331L21.9375 27.0594Z",
    fill: "#006CA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9316 13.5273L23.3359 24.3555L24.7359 27.0592H33.1316L34.5316 24.3555L28.9316 13.5273Z",
    fill: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0269 33.5897H22.8313V27.0578H34.0269V33.5897ZM34.0269 24.2578H22.8313C22.0886 24.2578 21.3765 24.5528 20.8514 25.0779C20.3263 25.603 20.0312 26.3152 20.0312 27.0578V33.5897C20.0312 35.1384 21.2825 36.3897 22.8313 36.3897H34.0269C35.5756 36.3897 36.8269 35.1384 36.8269 33.5897V27.0578C36.8269 25.5091 35.5756 24.2578 34.0269 24.2578Z",
    fill: "#F79329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4287 41.9878C42.4287 49.7184 36.1638 55.9834 28.4331 55.9834C20.7025 55.9834 14.4375 49.7184 14.4375 41.9878C14.4375 34.2572 20.7025 27.9922 28.4331 27.9922C36.1638 27.9922 42.4287 34.2616 42.4287 41.9878Z",
    fill: "#F79329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0482 38.5847C18.8644 38.5847 18.6807 38.5497 18.5057 38.4709C17.8319 38.1822 17.5082 37.399 17.7707 36.7165C17.7751 36.7034 17.7794 36.6947 17.7838 36.6859C17.7882 36.664 17.7882 36.6684 17.8013 36.6509C18.4138 35.1957 19.3629 33.9066 20.5707 32.8897C21.7785 31.8728 23.2105 31.1571 24.7488 30.8015C24.9019 30.7665 25.0638 30.8409 25.1338 30.9853C25.2038 31.1297 25.1644 31.3047 25.0376 31.4053C22.9944 33.0284 21.3626 35.2203 20.3169 37.7359C20.3169 37.7403 20.3126 37.7447 20.3126 37.7447C20.3126 37.749 20.3126 37.749 20.3082 37.7534C20.1638 38.0903 19.8969 38.3528 19.5557 38.484C19.3938 38.554 19.2188 38.5847 19.0482 38.5847Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0662 27.0594H22.8706L8.875 0H20.0706L34.0662 27.0594Z",
    fill: "#006CA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.31 48.9336H28.38C29.1718 48.9205 30.6725 48.7455 31.8187 47.7173C32.7725 46.8598 33.2143 45.6873 33.035 44.4973C32.8643 43.3905 32.1687 42.4498 31.1056 41.868C32.125 41.1023 32.7375 40.1442 32.8425 39.1467C32.9475 38.1798 32.5668 37.2173 31.7487 36.3598C30.9262 35.498 29.815 35.043 28.5418 35.043C26.5775 35.043 24.7706 36.0798 24.2237 36.8323C24.1756 36.8936 24.1756 36.9811 24.2193 37.0511L25.44 38.8142C25.4706 38.858 25.5143 38.8886 25.5668 38.893C25.615 38.9017 25.6718 38.8886 25.7112 38.8536C25.7243 38.8448 27.05 37.7555 28.1831 37.7555C28.6993 37.7555 29.08 37.983 29.3512 38.4467C29.5743 38.8361 29.6181 39.1905 29.4825 39.5317C29.1106 40.4505 27.5356 40.9186 27.5225 40.923C27.4437 40.9448 27.3868 41.0192 27.3868 41.1023V42.6555C27.3868 42.743 27.4437 42.8173 27.5312 42.8348C27.5487 42.8392 29.045 43.2111 29.3862 44.0686C29.5218 44.4055 29.4518 44.7861 29.185 45.2017C28.9006 45.6392 28.4718 45.8623 27.9075 45.8623C26.8137 45.8623 25.475 45.0311 24.8887 44.5105C24.8692 44.4931 24.8463 44.4798 24.8215 44.4715C24.7967 44.4633 24.7704 44.4601 24.7443 44.4623C24.6875 44.4667 24.6437 44.4973 24.6131 44.5411L23.3925 46.3042C23.3443 46.3742 23.3487 46.4661 23.4056 46.5317C23.48 46.6323 25.475 48.9336 28.31 48.9336Z",
    fill: "#AE3D09"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2146_3462"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportRankThird);
export default __webpack_public_path__ + "static/media/report_rank_third.2288258fd3242872708889fa2e6e7326.svg";
export { ForwardRef as ReactComponent };